import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiLogin, apiMe, apiLogout } from "./api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);   // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    apiMe()
      .then((u) => setUser(u))
      .catch(() => setUser(false))
      .finally(() => setReady(true));
  }, []);

  const login = useCallback(async (email, password) => {
    const u = await apiLogin(email, password);
    setUser(u);
    return u;
  }, []);

  const logout = useCallback(async () => {
    await apiLogout();
    setUser(false);
  }, []);

  return (
    <AuthCtx.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}
